import type { CodeProfile } from "./types";

export const TBDY_PROFILE: CodeProfile = {
  id: "tbdy2018",
  label: "TBDY 2018",
  verification: "resistance",
  references: [
    "Türkiye Bina Deprem Yönetmeliği (TBDY 2018), Bölüm 16 — Temel Zemini ve Temeller için Özel Kurallar, §16.12 İstinat Yapıları. Resmî Gazete 18.03.2018/30364.",
    "TS 7994 — Zemin Dayanma Yapıları; Sınıflandırma, Özellikleri ve Projelendirme Esasları.",
  ],
};
